export default {
    watch: {
        fixGuestCount(newVal) {
          if (newVal && this.fixGuestSetting?.fix_guest_count?.status) {
            this.initializeForm();
            this.populateCompanionsFields();
          }
        },
        fixGuestSetting(newVal) {
          if (newVal && newVal.fix_guest_count?.status) {
            this.populateCompanionsFields();
          }
        },
        companions(newValue) {
          this.guestLength = newValue.length; 
        },
        multiple_data(){},
        visitor_forms(){},
        checkin_form_type(val){
          if(val != '') {
            this.initializeForm();
          }
        },
    },
  };
  